import Page from '@app/components/layout/page/page';
import IngredientDetailForm from '../components/ingredient-detail-form';
import { useIngredientDetailContext } from '../ingredient-detail-context';

export default function IngredientDetailPage() {
  const { item, status } = useIngredientDetailContext();
  return (
    <Page name={item.name} page="subpage" status={status}>
      <IngredientDetailForm item={item} />
    </Page>
  );
}
